'use strict';

var _createForOfIteratorHelper = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _wrapAsyncGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var _awaitAsyncGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _asyncGeneratorDelegate = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncGeneratorDelegate");

function _asyncIterator(iterable) { var method, async, sync, retry = 2; if (typeof Symbol !== "undefined") { async = Symbol.asyncIterator; sync = Symbol.iterator; } while (retry--) { if (async && (method = iterable[async]) != null) { return method.call(iterable); } if (sync && (method = iterable[sync]) != null) { return new AsyncFromSyncIterator(method.call(iterable)); } async = "@@asyncIterator"; sync = "@@iterator"; } throw new TypeError("Object is not async iterable"); }

function AsyncFromSyncIterator(s) { AsyncFromSyncIterator = function AsyncFromSyncIterator(s) { this.s = s; this.n = s.next; }; AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function _return(value) { var ret = this.s.return; if (ret === undefined) { return Promise.resolve({ value: value, done: true }); } return AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments)); }, throw: function _throw(value) { var thr = this.s.return; if (thr === undefined) return Promise.reject(value); return AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments)); } }; function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) { return Promise.reject(new TypeError(r + " is not an object.")); } var done = r.done; return Promise.resolve(r.value).then(function (value) { return { value: value, done: done }; }); } return new AsyncFromSyncIterator(s); }

Object.defineProperty(exports, '__esModule', {
  value: true
});

var PeerId = require('peer-id');

var errCode = require('err-code');

var errors = require('../errors.js');

var get = require('dlv');

var withTimeoutOption = require('ipfs-core-utils/with-timeout-option');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

var PeerId__default = /*#__PURE__*/_interopDefaultLegacy(PeerId);

var errCode__default = /*#__PURE__*/_interopDefaultLegacy(errCode);

var get__default = /*#__PURE__*/_interopDefaultLegacy(get);

function createDht(_ref) {
  var network = _ref.network,
      repo = _ref.repo;
  var _get$put$findProvs$fi = {
    get: function get(key) {
      var _arguments = arguments;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var options, _yield$use, libp2p;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                options = _arguments.length > 1 && _arguments[1] !== undefined ? _arguments[1] : {};
                _context.next = 3;
                return use(network, options);

              case 3:
                _yield$use = _context.sent;
                libp2p = _yield$use.libp2p;
                return _context.abrupt("return", libp2p._dht.get(key, options));

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    put: function put(key, value, options) {
      return _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _yield$_awaitAsyncGen, libp2p;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _awaitAsyncGenerator(use(network, options));

              case 2:
                _yield$_awaitAsyncGen = _context2.sent;
                libp2p = _yield$_awaitAsyncGen.libp2p;
                return _context2.delegateYield(_asyncGeneratorDelegate(_asyncIterator(libp2p._dht.put(key, value)), _awaitAsyncGenerator), "t0", 5);

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    findProvs: function findProvs(cid) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        numProviders: 20
      };
      return _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var _yield$_awaitAsyncGen2, libp2p, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, peer;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _awaitAsyncGenerator(use(network, options));

              case 2:
                _yield$_awaitAsyncGen2 = _context3.sent;
                libp2p = _yield$_awaitAsyncGen2.libp2p;
                _iteratorAbruptCompletion = false;
                _didIteratorError = false;
                _context3.prev = 6;
                _iterator = _asyncIterator(libp2p._dht.findProviders(cid, {
                  maxNumProviders: options.numProviders,
                  signal: options.signal
                }));

              case 8:
                _context3.next = 10;
                return _awaitAsyncGenerator(_iterator.next());

              case 10:
                if (!(_iteratorAbruptCompletion = !(_step = _context3.sent).done)) {
                  _context3.next = 17;
                  break;
                }

                peer = _step.value;
                _context3.next = 14;
                return {
                  id: peer.id.toB58String(),
                  addrs: peer.addrs
                };

              case 14:
                _iteratorAbruptCompletion = false;
                _context3.next = 8;
                break;

              case 17:
                _context3.next = 23;
                break;

              case 19:
                _context3.prev = 19;
                _context3.t0 = _context3["catch"](6);
                _didIteratorError = true;
                _iteratorError = _context3.t0;

              case 23:
                _context3.prev = 23;
                _context3.prev = 24;

                if (!(_iteratorAbruptCompletion && _iterator.return != null)) {
                  _context3.next = 28;
                  break;
                }

                _context3.next = 28;
                return _awaitAsyncGenerator(_iterator.return());

              case 28:
                _context3.prev = 28;

                if (!_didIteratorError) {
                  _context3.next = 31;
                  break;
                }

                throw _iteratorError;

              case 31:
                return _context3.finish(28);

              case 32:
                return _context3.finish(23);

              case 33:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[6, 19, 23, 33], [24,, 28, 32]]);
      }))();
    },
    findPeer: function findPeer(peerId, options) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var _yield$use2, libp2p, peer;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return use(network, options);

              case 2:
                _yield$use2 = _context4.sent;
                libp2p = _yield$use2.libp2p;
                _context4.next = 6;
                return libp2p._dht.findPeer(PeerId__default["default"].parse(peerId));

              case 6:
                peer = _context4.sent;
                return _context4.abrupt("return", {
                  id: peer.id.toB58String(),
                  addrs: peer.multiaddrs
                });

              case 8:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    provide: function provide(cids) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        recursive: false
      };
      return _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var _yield$_awaitAsyncGen3, libp2p, cidArr, hasCids, hasAll, _iterator3, _step3, cid;

        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return _awaitAsyncGenerator(use(network, options));

              case 2:
                _yield$_awaitAsyncGen3 = _context5.sent;
                libp2p = _yield$_awaitAsyncGen3.libp2p;
                cidArr = Array.isArray(cids) ? cids : [cids];
                _context5.next = 7;
                return _awaitAsyncGenerator(Promise.all(cidArr.map(function (cid) {
                  return repo.blocks.has(cid);
                })));

              case 7:
                hasCids = _context5.sent;
                hasAll = hasCids.every(function (has) {
                  return has;
                });

                if (hasAll) {
                  _context5.next = 11;
                  break;
                }

                throw errCode__default["default"](new Error('block(s) not found locally, cannot provide'), 'ERR_BLOCK_NOT_FOUND');

              case 11:
                if (!options.recursive) {
                  _context5.next = 13;
                  break;
                }

                throw errCode__default["default"](new Error('not implemented yet'), 'ERR_NOT_IMPLEMENTED_YET');

              case 13:
                _iterator3 = _createForOfIteratorHelper(cidArr);
                _context5.prev = 14;

                _iterator3.s();

              case 16:
                if ((_step3 = _iterator3.n()).done) {
                  _context5.next = 22;
                  break;
                }

                cid = _step3.value;
                _context5.next = 20;
                return libp2p._dht.provide(cid);

              case 20:
                _context5.next = 16;
                break;

              case 22:
                _context5.next = 27;
                break;

              case 24:
                _context5.prev = 24;
                _context5.t0 = _context5["catch"](14);

                _iterator3.e(_context5.t0);

              case 27:
                _context5.prev = 27;

                _iterator3.f();

                return _context5.finish(27);

              case 30:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, null, [[14, 24, 27, 30]]);
      }))();
    },
    query: function query(peerId, options) {
      return _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var _yield$_awaitAsyncGen4, libp2p, _iteratorAbruptCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, closerPeerId;

        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return _awaitAsyncGenerator(use(network, options));

              case 2:
                _yield$_awaitAsyncGen4 = _context6.sent;
                libp2p = _yield$_awaitAsyncGen4.libp2p;
                _iteratorAbruptCompletion2 = false;
                _didIteratorError2 = false;
                _context6.prev = 6;
                _iterator2 = _asyncIterator(libp2p._dht.getClosestPeers(PeerId__default["default"].parse(peerId).toBytes()));

              case 8:
                _context6.next = 10;
                return _awaitAsyncGenerator(_iterator2.next());

              case 10:
                if (!(_iteratorAbruptCompletion2 = !(_step2 = _context6.sent).done)) {
                  _context6.next = 17;
                  break;
                }

                closerPeerId = _step2.value;
                _context6.next = 14;
                return {
                  id: closerPeerId.toB58String(),
                  addrs: []
                };

              case 14:
                _iteratorAbruptCompletion2 = false;
                _context6.next = 8;
                break;

              case 17:
                _context6.next = 23;
                break;

              case 19:
                _context6.prev = 19;
                _context6.t0 = _context6["catch"](6);
                _didIteratorError2 = true;
                _iteratorError2 = _context6.t0;

              case 23:
                _context6.prev = 23;
                _context6.prev = 24;

                if (!(_iteratorAbruptCompletion2 && _iterator2.return != null)) {
                  _context6.next = 28;
                  break;
                }

                _context6.next = 28;
                return _awaitAsyncGenerator(_iterator2.return());

              case 28:
                _context6.prev = 28;

                if (!_didIteratorError2) {
                  _context6.next = 31;
                  break;
                }

                throw _iteratorError2;

              case 31:
                return _context6.finish(28);

              case 32:
                return _context6.finish(23);

              case 33:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, null, [[6, 19, 23, 33], [24,, 28, 32]]);
      }))();
    }
  },
      get = _get$put$findProvs$fi.get,
      put = _get$put$findProvs$fi.put,
      findProvs = _get$put$findProvs$fi.findProvs,
      findPeer = _get$put$findProvs$fi.findPeer,
      provide = _get$put$findProvs$fi.provide,
      query = _get$put$findProvs$fi.query;
  return {
    get: withTimeoutOption.withTimeoutOption(get),
    put: withTimeoutOption.withTimeoutOption(put),
    findProvs: withTimeoutOption.withTimeoutOption(findProvs),
    findPeer: withTimeoutOption.withTimeoutOption(findPeer),
    provide: withTimeoutOption.withTimeoutOption(provide),
    query: withTimeoutOption.withTimeoutOption(query)
  };
}

var use = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(network, options) {
    var net;
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            _context7.next = 2;
            return network.use(options);

          case 2:
            net = _context7.sent;

            if (!get__default["default"](net.libp2p, '_config.dht.enabled', false)) {
              _context7.next = 7;
              break;
            }

            return _context7.abrupt("return", net);

          case 7:
            throw new errors.NotEnabledError('dht not enabled');

          case 8:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));

  return function use(_x, _x2) {
    return _ref2.apply(this, arguments);
  };
}();

exports.createDht = createDht;